
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KeyData } from '@clients/bff';
import StatisticFrequency from '@/models/statistic/StatisticFrequency';
import StatisticItem from '@/components/statistic/StatisticItem.vue';
import { namespace } from 'vuex-class';
import AppListItemPlaceholder from '@components/new-styleguide/AppListItemPlaceholder.vue';

const StatisticModule = namespace('Statistic');

@Component({
  name: 'KeyDataTab',
  components: {
    StatisticItem,
    AppListItemPlaceholder
  },
})
export default class KeyDataTab extends Vue {
  @Prop()
  private keyData: KeyData;

  @Prop()
  private loading: boolean;

  @StatisticModule.Getter('getAverageSelection')
  private averageSelection: StatisticFrequency;

  @StatisticModule.Mutation('SET_AVERAGE_SELECTION')
  private setAverageSelection;

  get summary() {
    return this.keyData.summary;
  }

  get highlights() {
    return this.keyData.highlights;
  }

  get averages() {
    return this.keyData.averages[this.averageSelection];
  }

  onChange(e) {
    this.setAverageSelection(e.target.value);
  }

  get highlightPlaceholdersAmount() {
    return 7;
  }
  get averagesPlaceholdersAmount() {
    return 5;
  }

  navigateToHighlightTrip(tripId) {
    if (tripId) {
      this.$router.push({ name: 'myTripsEdit', params: { id: tripId.toString(), fromStatistic: true.toString() } })
    }
  }
}
